const NATIVELY_FOCUSABLE = ['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA']

function ensureFocusable(el) {
    const isNativelyFocusable = NATIVELY_FOCUSABLE.includes(el.tagName)
    const hasTabindex = el.hasAttribute('tabindex')

    if (!isNativelyFocusable && !hasTabindex) {
        el.setAttribute('tabindex', '0')
    }
}

function buildOptions(binding) {
    const raw = typeof binding.value === 'string'
        ? { title: binding.value }
        : { ...binding.value }

    const isPopover = raw.popover === true
    delete raw.popover

    // Popover uses `content`, Tooltip uses `title` — normalize so
    // callers can always just pass `title` regardless of which one they want.
    if (isPopover && raw.title !== undefined && raw.content === undefined) {
        raw.content = raw.title
        delete raw.title
    }

    return { isPopover, options: raw }
}

function createInstance(el, binding) {
    if (typeof window.bootstrap === 'undefined') return null

    const { isPopover, options } = buildOptions(binding)
    const Constructor = isPopover ? window.bootstrap.Popover : window.bootstrap.Tooltip

    return new Constructor(el, { trigger: 'hover focus', ...options })
}

function getComparableText(binding) {
    if (typeof binding.value === 'string') return binding.value
    return binding.value?.title ?? binding.value?.content
}

export default {
    mounted(el, binding) {
        if (typeof window.bootstrap === 'undefined') return
        ensureFocusable(el)
        el._wnPopper = createInstance(el, binding)
    },
    updated(el, binding) {
        if (typeof window.bootstrap === 'undefined') return

        const newText = getComparableText(binding)
        const oldText = getComparableText({ value: binding.oldValue })
        if (newText === oldText) return

        ensureFocusable(el)
        el._wnPopper?.dispose()
        el._wnPopper = createInstance(el, binding)
    },
    beforeUnmount(el) {
        el._wnPopper?.dispose()
        el._wnPopper = null
    },
}